import type { PersistedSegmentationState } from '../../../redux/reducers/segmentation/segmentationFeature'

export const SEGMENTATION_HISTORY_STATE_KEY = 'centralListingsSegmentation'

export const getPersistedSegmentationState = (): PersistedSegmentationState | undefined => {
  const historyState = window.history.state as
    | (Record<string, unknown> & {
        [SEGMENTATION_HISTORY_STATE_KEY]?: PersistedSegmentationState
      })
    | null

  if (!historyState?.[SEGMENTATION_HISTORY_STATE_KEY]) {
    return undefined
  }

  const { [SEGMENTATION_HISTORY_STATE_KEY]: persistedState, ...remainingState } = historyState
  window.history.replaceState(remainingState, '')
  return persistedState
}

export const persistSegmentationState = (state: PersistedSegmentationState) => {
  window.history.replaceState(
    {
      ...(window.history.state ?? {}),
      [SEGMENTATION_HISTORY_STATE_KEY]: state,
    },
    ''
  )
}
